var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"intro"},[_c('div',{staticClass:"container intro__content"},[_c('h2',{staticClass:"intro__content__title"},[_vm._v("Bem-vindo ao\n            Blog Fibrilare")]),_c('h3',{staticClass:"intro__content__subtitle"},[_vm._v("Fique por dentro de todas\n            as tendências do mercado")])])])
}]

export { render, staticRenderFns }